var mixerElement = document.getElementById("filterContainer");

if (typeof(mixerElement) != 'undefined' && mixerElement != null)
{
    
    var hasFilterAll = document.getElementById("filterAll");
    if (hasFilterAll) {
        var setFilter = 'all'
    } else {
        var setFilter = '.cat-7af1ec'
    }

    var mixer = mixitup(mixerElement, {
        load: {
            filter: setFilter
        }
    });

    var containerEl = document.querySelector('.mixitupContent');
    var selectFilter = document.querySelector('#mixitup-tab');

    var mixer = mixitup(containerEl);

    selectFilter.addEventListener('change', function() {
        var selector = selectFilter.value;

        mixer.filter(selector);
    });

}